(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[820],{

/***/ 36582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(91736);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ helper_image; }
});

// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./src/components/helper/serialize.js
function serialize(obj, prefix) {
    var str = [];
    var p;
    // eslint-disable-next-line no-restricted-syntax
    for(p in obj){
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? "".concat(prefix, "[").concat(p, "]") : p;
            var v = obj[p];
            str.push(v !== null && typeof v === 'object' ? serialize(v, k) : "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v)));
        }
    }
    return str.join('&');
}
/* harmony default export */ var helper_serialize = (serialize);

;// CONCATENATED MODULE: ./src/components/helper/image.js


var parse = function(photo, params) {
    var query = params || {};
    if (typeof photo === 'undefined' || !photo) {
        return '';
    }
    var p = photo;
    if (photo.indexOf('yachtsys.com') !== -1) {
        p = photo.replace('https://media.yachtsys.com', '/yachtsys');
    } else if (photo.indexOf('booking-manager.com') !== -1) {
        p = photo.replace('https://www.booking-manager.com', '/mmk');
    } else if (photo.indexOf('ws.nausys.com') !== -1) {
        p = photo.replace('https://ws.nausys.com', '/nausys');
    } else if (photo.indexOf('sednasystem.com') !== -1) {
        p = photo.replace('https://api1.sednasystem.com', '/sedna');
    } else if (photo.indexOf('api.chartercheck.com/fileadmin') !== -1) {
        p = photo.replace('https://api.chartercheck.com/fileadmin', '/fileadmin');
        if (!query.w) {
            query.w = 1500;
        }
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && !/connect\.5-anker\./i.test(p)) {
        return p;
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && /connect\.5-anker\./i.test(p)) {
        return "".concat(p, "?").concat(helper_serialize(params));
    }
    return "".concat(app_config/* default.endpoint */.Z.endpoint + p, "?").concat(helper_serialize(query));
};
/* harmony default export */ var helper_image = (parse);


/***/ }),

/***/ 89388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _components_helper_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1075);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SEO(param) {
    var _description = param.description, description = _description === void 0 ? '' : _description, _author = param.author, author = _author === void 0 ? 'Chartercheck' : _author, _meta = param.meta, meta = _meta === void 0 ? [] : _meta, _title = param.title, title = _title === void 0 ? 'Chartercheck' : _title, _canonicalUrl = param.canonicalUrl, canonicalUrl = _canonicalUrl === void 0 ? '' : _canonicalUrl, _image = param.image, image = _image === void 0 ? '' : _image, _robots = param.robots, robots = _robots === void 0 ? 'index, follow' : _robots;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pageImage = image ? (0,_components_helper_image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(image.publicUrl) : '';
    var canonicalUrlGen = canonicalUrl || router.asPath.split('?')[0];
    // prepend the base url to the canonical url
    if (canonicalUrlGen.indexOf('http') !== 0) {
        // remove first slash if it exists
        canonicalUrlGen = canonicalUrlGen.replace(/^\//, '');
        canonicalUrlGen = "".concat("https://www.chartercheck.com", "/").concat(canonicalUrlGen);
    }
    var metaData = [
        {
            name: 'robots',
            content: robots
        },
        {
            name: 'description',
            content: description
        },
        {
            property: 'og:site_name',
            content: 'Chartercheck'
        },
        {
            property: 'og:locale',
            content: router.locale
        },
        {
            property: 'og:author',
            content: author
        },
        {
            property: 'og:publisher',
            content: author
        },
        {
            property: 'og:title',
            content: title
        },
        {
            property: 'og:description',
            content: description
        },
        {
            property: 'og:type',
            content: 'website'
        },
        {
            property: 'og:url',
            content: router.asPath
        },
        {
            property: 'og:image',
            content: pageImage
        }, 
    ].filter(function(i) {
        return i.content;
    }).concat(meta);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrlGen
            }),
            metaData.map(function(props, k) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", _objectSpread({}, props), "meta-".concat(k));
            }),
            pageImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: pageImage
            })
        ]
    }));
};
SEO.defaultProps = {
    meta: [],
    description: ''
};


/***/ }),

/***/ 51190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ UserErrorPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_helper_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89388);
/* harmony import */ var _components_elements_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81474);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var _components_helper_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);





function UserErrorPage(param) {
    var statusCode = param.statusCode, _title = param.title, title = _title === void 0 ? 'Seite nicht gefunden' : _title;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "".concat(statusCode || 'Ups!', " - ").concat(title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0 relative overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-2 min-h-screen",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-start justify-center relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "my-2 font-bold text-4xl",
                                    children: "Es ist ein Fehler aufgetreten - bitte entschuldigen Sie."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "my-2 text-gray-800 mb-20 text-lg",
                                    children: [
                                        "Sie k\xf6nnen den Vorgang wiederholen oder unser",
                                        ' ',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            href: "/kontakt",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "underline",
                                                children: "Kontaktformular"
                                            })
                                        }),
                                        ' ',
                                        "nutzen."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    href: "/",
                                    variant: "primary",
                                    children: "Zur Startseite"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    style: {
                                        fontSize: '20rem'
                                    },
                                    className: "font-bold text-primary-700 pointer-events-none opacity-10 absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2",
                                    children: statusCode
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-col items-center justify-center hidden md:flex",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                src: "/images/Group.png",
                                width: 300,
                                alt: "Broke",
                                height: 200,
                                objectFit: "contain"
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 91736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92876);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19985);
/* harmony import */ var _UserErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51190);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function MyError(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
        // getInitialProps is not called in case of
        // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
        // err via _app.js so it can be captured
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
    // Flushing is not required in this case as it only happens on the client
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UserErrorPage__WEBPACK_IMPORTED_MODULE_3__["default"], {
        statusCode: statusCode
    }));
}
MyError.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var errorInitialProps, res, err, asPath;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return next_error__WEBPACK_IMPORTED_MODULE_2__["default"].getInitialProps(context);
                case 2:
                    errorInitialProps = _ctx.sent;
                    res = context.res, err = context.err, asPath = context.asPath;
                    // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
                    // getInitialProps has run
                    errorInitialProps.hasGetInitialPropsRun = true;
                    if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 404)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", errorInitialProps);
                case 7:
                    if (!err) {
                        _ctx.next = 12;
                        break;
                    }
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
                    _ctx.next = 11;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 11:
                    return _ctx.abrupt("return", errorInitialProps);
                case 12:
                    // If this point is reached, getInitialProps was called without any
                    // information about what the error might be. This is unexpected and may
                    // indicate a bug introduced in Next.js, so record it in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error("_error.js getInitialProps missing data at path: ".concat(asPath)));
                    _ctx.next = 15;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 15:
                    return _ctx.abrupt("return", errorInitialProps);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = (MyError);


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(36582); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);